import './settings.tpl.html';

angular
  .module('bulkExport.settings', ['services.error'])
  /**
   * Controller for the restore.confirm template.
   */
  .controller('BulkExportSettingsCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    '$filter',
    '$q',
    'BulkRestoreService',
    'ErrorService',
    'WizardService',
    function ($scope, $rootScope, $state, $filter, $q, BulkRestoreService, ErrorService, WizardService) {
      if (!$state.params.bulkRestoreData) {
        throw new Error('bulkRestoreData is required');
      }

      var i18n = $filter('i18n');
      var bulkRestoreData = $state.params.bulkRestoreData;
      var model;

      // Published functions
      $scope.canIncludeChildren = canIncludeChildren;
      $scope.getPageTitle = getPageTitle;
      $scope.getRecordNamesText = getRecordNamesText;
      $scope.isIncludingChildren = isIncludingChildren;
      $scope.toggleIncludingChildren = toggleIncludingChildren;

      // Publish the bulk restore data
      $scope.bulkRestoreData = bulkRestoreData;

      // Store data in a model object rather than the scope itself for easier watching
      $scope.model = model = {
        recordCount: bulkRestoreData.getSelectedObjectRecordsCountInfo().text
      };

      // Register our page with the wizard service
      var page = WizardService.getCurrentPage();
      page.setHeaderText(i18n('SELECT_EXPORT_SETTINGS'));
      page.setStateParams($state.params);
      page.setValid(true);
      // For the purposes of confirming cancellation of the wizard we'll consider the wizard touched if we get this far.
      page.setTouched(true);

      /**
       * Utility method to get the value to display for the setting title section.
       *
       * @returns {string} The title text to display.
       */
      function getPageTitle() {
        var title, objectType;

        const selectedObjectTypes = bulkRestoreData.getSelectedObjectTypes();
        if (!selectedObjectTypes) {
          if (bulkRestoreData.isRestoreFromCsv()) {
            objectType = bulkRestoreData.getSelectedObjectRecordTypes().join(',');
          } else {
            objectType = bulkRestoreData.getSearchObjectType();
          }

          if (model.recordCount === 1) {
            title = i18n('CONFIRM_EXPORT_RECORD', objectType);
          } else {
            title = i18n('CONFIRM_EXPORT_RECORDS', [model.recordCount, objectType]);
          }
        } else {
          if (selectedObjectTypes.selectedAll) {
            title = i18n('ALL_OBJECTS');
          } else {
            const selectedMultipleObjects = bulkRestoreData.checkObjectTypeSelectedCount(2);
            title = selectedMultipleObjects
              ? i18n('CONFIRM_RESTORE_OBJECTS', [
                  selectedObjectTypes.selectedList.length,
                  selectedObjectTypes.selectedList.join(', ')
                ])
              : i18n('CONFIRM_RESTORE_OBJECT', [selectedObjectTypes.selectedList[0]]);
          }
        }

        return title;
      }

      /**
       * Returns the text used to display the names of the selected records.
       *
       * @returns {string} the record names text.
       */
      function getRecordNamesText() {
        if (!bulkRestoreData.canGetSelectedObjectRecords()) {
          // This can happen if the user is selecting "all" and there is more than one page of results. In this case
          // we won't try to show the names.
          return '';
        }

        var names = bulkRestoreData.getSelectedObjectRecordNames();
        // We want to offset the names with a dash.
        return ' - ' + names.join(', ');
      }

      /**
       * Toggles whether the user wants to include children of deleted records.
       */
      function toggleIncludingChildren() {
        bulkRestoreData.setIncludingChildren(!bulkRestoreData.isIncludingAllChildren());
      }

      /**
       * Determines whether the user wants to include children of deleted records.
       *
       * @returns {boolean} true if the user wants to include children.
       */
      function isIncludingChildren() {
        return bulkRestoreData.isIncludingAllChildren();
      }

      /**
       * Determines whether the option to include children in the restore should be shown
       *
       * @returns {boolean} true if the option should be shown.
       */
      function canIncludeChildren() {
        // Always show this for CSV uploads
        if (bulkRestoreData.isRestoreFromCsv()) {
          return true;
        }

        if (bulkRestoreData.isManualObjectBrowse()) {
          return false;
        }

        // We only show the option if the selected records contain any deleted records.
        return bulkRestoreData.hasSelectedDeletedObjects();
      }
    }
  ]);
